import { observer } from 'mobx-react-lite'
import { MergeAccountsDialog } from '@/features/admin/account-linking/MergeAccountsDialog'
import { type MergeAccountsDialogViewModel } from './MergeAccountsDialogViewModel'

export interface MergeAccountsDialogContainerProps {
  vm: MergeAccountsDialogViewModel
}

export const MergeAccountsDialogContainer = observer(
  function MergeAccountsDialogContainer({
    vm,
  }: MergeAccountsDialogContainerProps) {
    return (
      <MergeAccountsDialog
        showing={vm.modal.showing}
        onClose={vm.cancel}
        onLink={vm.link}
        isLinkPending={vm.link.pending}
        displayName={vm.displayName}
      />
    )
  },
)
